class Guest {
  constructor() {
    this.profileId = "";
    this.title = "";
    this.firstName = "";
    this.lastName = "";
    this.email = "";
    this.country = "";
    this.countryCode = "";
    this.userNationality = "";
    this.nationality = "";
    this.nationalityCode = "";
    this.phoneCode = "0";
    this.phone = "";
    this.birthday = "";
    this.passport = "";
    this.dateOfExpiry = "";
    this.tmSix = "";
    this.document = "";
    this.signature = "";
    this.verified = false;
    this.idType = "";
    this.clientSecret = null;
    this.stripeSubmitted = false;
    this.completed = false;
    this.saveVerificationToProfile = false;
    this.preCheckedInCompleted = "";
    this.overrideIsVerifiedFlag = "";
    this.licensePlate = "";
    this.accountExist = "";
    this.children = "";
    this.avatar = "";
    this.mainGuest = "";
    this.editable = true;
    this.currentGuest = "";
    this.guestId = "";
    this.id = "";
    this.address = null;
    this.ageGroup = null;
    this.preferences = [];
  }
  getData() {
    return {
      profileId: this.profileId,
      title: this.title,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      country: this.country,
      countryCode: this.countryCode,
      userNationality: this.userNationality,
      nationality: this.nationality,
      nationalityCode: this.nationalityCode,
      phoneCode: this.phoneCode,
      phone: this.phone,
      birthday: this.birthday,
      passport: this.passport,
      dateOfExpiry: this.dateOfExpiry,
      tmSix: this.tmSix,
      document: this.document,
      signature: this.signature,
      completed: this.completed,
      clientSecret: this.clientSecret,
      stripeSubmitted: this.stripeSubmitted,
      verified: this.verified,
      idType: this.idType,
      saveVerificationToProfile: this.saveVerificationToProfile,
      preCheckedInCompleted: this.preCheckedInCompleted,
      overrideIsVerifiedFlag: this.overrideIsVerifiedFlag,
      licensePlate: this.licensePlate,
      accountExist: this.accountExist,
      children: this.children,
      avatar: this.avatar,
      mainGuest: this.mainGuest,
      editable: this.editable === false ? false : true,
      currentGuest: this.currentGuest,
      guestId: this.guest_id,
      id: this.id,
      guest_id: this.guest_id,
      address: this.address,
      ageGroup: this.ageGroup,
      preferences: this.preferences || [],
    };
  }
  setData(obj) {
    this.profileId = obj.profile_id || obj.profileId || "";
    this.title = obj.title || "";
    this.firstName = obj.firstName || obj.first_name || "";
    this.lastName = obj.lastName || obj.last_name || "";
    this.email = obj.email || "";
    this.country = obj.country || "";
    this.countryCode = obj.countryCode || "";
    this.userNationality = obj.userNationality || "";
    this.nationality = obj.nationality || "";
    this.nationalityCode = obj.nationalityCode || "";
    this.phone = obj.phone || "";
    this.phoneCode = obj.phoneCode || "0";
    this.birthday = obj.birthday || "";
    this.passport = obj.passport || "";
    this.dateOfExpiry = obj.dateOfExpiry || "";
    this.tmSix = obj.tmSix || "";
    this.document = obj.document || "";
    this.signature = obj.signature || "";
    this.completed = obj.completed || "";
    this.clientSecret = obj.clientSecret || "";
    this.stripeSubmitted = obj.stripeSubmitted || false;
    this.idType = obj.idType || "";
    this.verified = obj.verified || false;
    this.saveVerificationToProfile = obj.saveVerificationToProfile || false;
    this.preCheckedInCompleted =
      obj.preCheckedInCompleted || obj.pre_checked_in_completed || false;
    this.overrideIsVerifiedFlag = obj.overrideIsVerifiedFlag || false;
    this.licensePlate = obj.licensePlate || obj.license_plate || false;
    this.accountExist = obj.accountExist || obj.account_exist || false;
    this.children = obj.children || [];
    this.avatar = obj.avatar || null;
    this.mainGuest = obj.mainGuest || false;
    this.editable = obj.editable === false ? false : true;
    this.currentGuest = obj.currentGuest || false;
    this.guestId = obj.guestId || obj.guest_id || "";
    this.address = obj.address || null;
    this.ageGroup = obj.age_group || obj.ageGroup || null;
    this.preferences = obj.preferences || [];
  }
}

export default Guest;
